export default __webpack_public_path__ + "static/media/begin.c26ba11b.png";